import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { SolidPlay } from '@factorialco/f0-react/icons/app'
import { UpsellLandingPagesQuery } from 'generated/resources/graphql'

import { GradientMediaContainer } from './FeaturesSection'

type UpsellSection = NonNullable<
  NonNullable<
    NonNullable<UpsellLandingPagesQuery['upsell']['landingPagesConnection']['edges'][0]>['node']
  >['sections']
>[0]

interface MediaSectionProps {
  content: UpsellSection | undefined
}

export const MediaSection = ({ content }: MediaSectionProps) => {
  const videoId = content?.mediaUrl?.split('v=')[1]?.split('&')[0]

  return (
    <Box
      className="mx-auto"
      alignItems="center"
      textAlign="center"
      gap="s16"
      style={{ marginTop: '80px' }}
    >
      <Text size="700" color="black" weight="bold">
        {content?.title || ''}
      </Text>

      {content?.description && (
        <Text size="400" className="mb-4">
          {content?.description || ''}
        </Text>
      )}

      <F0Button
        variant="outline"
        icon={SolidPlay}
        label={content?.buttonLabel}
        width="fit-content"
        onClick={() => window.open(content?.actionUrl || '', '_blank')}
      />

      <Box
        paddingTop="s48"
        paddingBottom="s80"
        borderRadius={{ all: 'abs016' }}
        className="max-h-[450px] w-[800px]"
        position="relative"
      >
        <GradientMediaContainer maxWidth="800px">
          {videoId ? (
            <iframe
              width="800px"
              height="446px"
              src={`https://www.youtube.com/embed/${videoId}`}
              allowFullScreen
              style={{
                borderRadius: '6px 6px 14px 14px',
              }}
            />
          ) : content?.media?.url?.includes('.mp4') ? (
            <video
              src={content?.media?.url || ''}
              className="rounded-lg max-h-[450px]"
              style={{
                display: 'block',
                width: '100%',
                height: '100%',
                borderRadius: '8px',
                justifyContent: 'center',
              }}
              autoPlay
              muted
              loop
            />
          ) : (
            <img src={content?.media?.url || ''} alt={content?.media?.alt || ''} />
          )}
        </GradientMediaContainer>
      </Box>
    </Box>
  )
}
